import React, { FunctionComponent, useContext } from 'react';
import { Box, Typography } from '@material-ui/core';
import { PostCodeContext } from '../../react/PostCodeContext';
import disclaimersSectionStyles from './disclaimersSectionStyles';
import useGetPostCode from '../../react/useGetPostCode';
import Translation from '../../components/translation/Translation';

export interface IDisclaimersSectionProps {
  disclaimerSectionId: string;
}

const DisclaimersSection: FunctionComponent<IDisclaimersSectionProps> = ({ disclaimerSectionId }) => {
  const { openModal } = useContext(PostCodeContext);
  const style = disclaimersSectionStyles();
  const postcode = useGetPostCode();

  const postcodeValue: () => JSX.Element = () => (
    <Box
      component="span"
      data-test="text:footer:postcode_modal_cta"
      className={style.postcode}
      onClick={() => openModal(true)}
    >
      <Translation
        id="spc.productCatalog.carPrice.disclaimer.postcode"
        values={{
          postcodeValue: postcode,
        }}
      />
    </Box>
  );

  return (
    <>
      <Typography data-test="container:footer:disclaimer" className={style.wrapper} id={disclaimerSectionId}>
        <Typography component="span" className={style.disclaimerTitle} data-test="text:footer:disclaimer_title">
          <Translation id="spc.productCatalog.carPrice.disclaimer.title" />
        </Typography>
        <Translation
          data-test="text:footer:disclaimer_content"
          id="spc.productCatalog.carPrice.disclaimer.primaryPrice"
          values={{
            postcode: postcodeValue(),
          }}
        />
      </Typography>
    </>
  );
};

export default DisclaimersSection;
